import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IItem, IKeyValue } from '../../models/group-edit-config';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from '../../../../services/company.service';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';

@Component({
  selector: 'app-input-edit-location',
  templateUrl: './input-edit-location.component.html',
  styleUrls: ['./input-edit-location.component.scss']
})
export class InputEditLocationComponent implements OnInit, OnDestroy {
    @Input() config: IItem;
    @Input() control: FormControl;

    sub = new Subject();
    useProviderLocation = false;
    trackingList: IKeyValue[] = [];
    errorMatcher = new CustomErrorStateMatcher();

    constructor(private comp: CompanyService) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(takeUntil(this.sub))
            .subscribe(c => {
                if(c){
                    this.useProviderLocation = c.useProviderLocation;
                }
            });

        this.comp.LocationTrackingData.pipe(takeUntil(this.sub))
            .subscribe(data => {
                if(this.useProviderLocation){
                    if(data){
                        if(data.length === 0){
                            this.trackingList = [{key: '', value: '*** no location data found'}];
                        }else{
                            this.trackingList = data;
                        }
                    }else{
                        this.trackingList = [{key: '', value: '-loading external data'}];
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

}
